import request from "@/api";

export function listOrder(data) {
    return request({
        url: '/api/order/getOrderList',
        method: 'get',
        params: data
    })
}

export function getOrderCount(data) {
    return request({
        url: '/api/order/getOrderCount',
        method: 'get',
        params: data
    })
}


export function getOrderInfo(data) {
    return request({
        url: '/api/order/getOrderInfo',
        method: 'get',
        params: data
    })
}

export function saveOrder(data) {
    return request({
        url: '/api/order/saveOrder',
        method: 'post',
        data: data
    })
}

export function batchSaveOrderAccount(data) {
    return request({
        url: '/api/order/batchSaveOrderAccount',
        method: 'post',
        data: data
    })
}

export function batchSaveOrderStatus(data) {
    return request({
        url: '/api/order/batchSaveOrderStatus',
        method: 'post',
        data: data
    })
}

export function batchSaveOrderSupplier(data) {
    return request({
        url: '/api/order/batchSaveOrderSupplier',
        method: 'post',
        data: data
    })
}

export function deleteOrder(data) {
    return request({
        url: '/api/order/deleteOrder',
        method: 'post',
        data: data
    })
}

export function deleteBatchOrder(data) {
    return request({
        url: '/api/order/deleteBatchOrder',
        method: 'post',
        data: data
    })
}

export function exportOrder(data) {
    return request({
        url: '/api/order/exportOrder',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportOrderSupplier(data) {
    return request({
        url: '/api/order/exportOrderSupplier',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}


export function exportSaleOrder(data) {
    return request({
        url: '/api/order/exportSaleOrder',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportSaleOrderSupplier(data) {
    return request({
        url: '/api/order/exportSaleOrderSupplier',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportVerifyOrder(data) {
    return request({
        url: '/api/order/exportVerifyOrder',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportVerifyOrderSupplier(data) {
    return request({
        url: '/api/order/exportVerifyOrderSupplier',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}